import core = require('../../core');
import context = require('../context');
import utilities = require('../utilities');
import common = require('../../common');
import Vue from 'vue';
import NotificationsVue = require('../vue/NotificationsVue');
import AjaxService = require('../../services/AjaxService');

//declare function require(name: string): any;

//var jsUtilities = require('../../js/jsUtilities');
//var jsClasses = require('../../js/jsClasses');

interface IFetchResponseData {
    results: common.IMessage[];
}

interface IUpdateStatusResponseData {
    updatedStatus: NotificationStatus;
    updatedItemIds: string[];
}

enum NotificationStatus {
    unknown = 'unknown',
    read = 'read',
    assigned = 'assigned',
    deleted = 'deleted'
}
interface ISettings {
    rootId: string;
}
class Notifications implements common.IWebComponent {
    private _isInit = false;
    private _vue: NotificationsVue;
    private _rootId: string;
    private _ajaxService: AjaxService;
    private _fetchApiUrl: string;

    init(s: ISettings) {
        if (this._isInit)
            return;
        this._isInit = true;

        this._rootId = s.rootId;
        this._fetchApiUrl = context.webServices.openNotificationsApiUrl;
        this._ajaxService = new AjaxService();

        this.setupVue();

        return context.components.add(this);
    }

    setupVue() {
        Vue.prototype.$initialData = {
            vueElId: this._rootId
        };

        this._vue = new NotificationsVue();

        this._vue
            .setOnClickCallback(() => this.onClick())
            .setOnItemClickCallback(message => this.onItemClick(message))
            .setOnItemLinkClickCallback(message => this.onItemLinkClick(message))
            .setOnDeleteAllClickCallback(() => this.onDeleteAllClick())
            .setOnDeleteItemClickCallback(message => this.onDeleteItemClick(message));
    }

    setTotalUnread(value?: number) {
        this._vue.setTotalUnread(value);
        return this;
    }

    /** defaut: 1 */
    decreaseTotalUnread(value?: number) {
        value = value || 1;
        const t = this._vue.totalUnread;
        const v = Math.max(0, t - value);
        return this.setTotalUnread(v);
    }

    /** defaut: 1 */
    increaseTotalUnread(value?: number) {
        value = value || 1;
        const t = this._vue.totalUnread;
        const v = Math.max(0, t + value);
        return this.setTotalUnread(v);
    }

    /** 
     Rafraichit la popup de notifications SI ELLE EST OUVERTE SEULEMENT.
     Retournera TRUE si le refresh a ete effectue.
    */
    refresh() {
        if (!this._vue.isOpen)
            return false;

        this.fetch(true);

        return true;
    }

    private onClick() {
        this.togglePopup();
    }

    private onItemClick(message: common.IMessage) {

        const url = message.clickUrl;
        if (url) {
            const asBlank = message.clickAsBlank === true;
            utilities.redirect(url, asBlank);
            return;
        }
    }

    private onDeleteItemClick(message: common.IMessage) {
        this.updateStatus(NotificationStatus.deleted, [message.id]);
    }

    private onDeleteAllClick() {
        this.updateStatus(NotificationStatus.deleted);
    }

    private onItemLinkClick(message: common.IMessage) {

        const apiUrl = message.linkUrl;

        if (apiUrl) {
            const asBlank = message.linkAsBlank === true;

            if (!this._ajaxService)
                this._ajaxService = new AjaxService();

            this._ajaxService.post(apiUrl, null, true, (data: common.IMessageClickResponseData) => {
                if (!data)
                    return;

                if (data.url) {
                    utilities.redirect(data.url, asBlank || false);
                    return;
                }

            }, (errors, config) => {
                utilities.printError("Une erreur est survenue lors de la collect des messages aupres de l'API. " + utilities.errorsToString(errors));
            });
        }
    }

    private togglePopup() {
        if (this._vue.isOpen) {
            this._vue.open(false);
            return;
        }

        const f = () => {
            this.fetch();
        };

        if (context.components.getMessagesManager().hasMessages()) {
            // fermer les messages 
            context.components.getMessagesManager().closeAll();

            // laisser le temps aux messages de se fermer.
            setTimeout(f, 175);

            return;
        }

        f();
    }

    private onFetchSuccess(data: IFetchResponseData, isRefresh: boolean) {

        const items = data.results || [] as common.IMessage[];
        const resetNotifications = !isRefresh;
        const updatedNotificationIds = this._vue.setItems(items, resetNotifications);

        if (items.length)
            this.setTotalUnread();

        this._vue.$nextTick(() => {
            this._vue.open();
            this.updateStatus(NotificationStatus.read, resetNotifications ? null : updatedNotificationIds, false);
        });
    }

    private onFetchError(e: common.IError[]) {
        (e || []).forEach(x =>
            context.components.getMessagesManager().displayErrorAsMessage(x));
        this._vue.open(false);
    }

    private onUpdateStatusSuccess(data: IUpdateStatusResponseData, updateUi?: boolean) {

        if (!updateUi)
            return;

        if (data.updatedStatus === NotificationStatus.deleted) {
            if (data.updatedItemIds)
                this._vue.setMessageStatusAsDeleted(data.updatedItemIds);
            else
                this._vue.setAllMessagesStatusAsDeleted();
        } else if (data.updatedStatus === NotificationStatus.read) {
            this._vue.setMessageStatusAsRead(data.updatedItemIds);
        }
    }

    private onUpdateStatusError(e: common.IError[]) {
        (e || []).forEach(x =>
            context.components.getMessagesManager().displayErrorAsMessage(x));
    }

    private fetch(isRefresh?: boolean) {
        isRefresh = isRefresh === true;

        this._ajaxService.post(this._fetchApiUrl, null, true, (responseData: IFetchResponseData) => {
            //SUCCESS
            if (responseData) {
                this.onFetchSuccess(responseData, isRefresh);
            } else {
                const e = new core.Error("Les données retournées par le système de mise à jour des notifications sont invalides.");
                this.onFetchError([e]);
            }
        }, (errors, config) => {
            this.onFetchError(errors);
        });
    }

    private updateStatus(status: NotificationStatus, ids?: string[], updateUi?: boolean) {
        ids = ids || null;
        updateUi = updateUi !== false;// default is TRUE

        const updateAll = !ids;
        var url: string;

        if (status === NotificationStatus.read)
            url = updateAll
                ? context.webServices.updateAllNotificationsAsRead
                : context.webServices.updateNotificationsAsRead;
        else if (status === NotificationStatus.deleted)
            url = updateAll
                ? context.webServices.updateAllNotificationsAsDeleted
                : context.webServices.updateNotificationsAsDeleted;
        else
            throw "Le update du status de notification '" + status + "' n'est pas implemente.";

        const a = {
            itemIds: ids
        };

        this._ajaxService.post(url, a, true, (responseData: IUpdateStatusResponseData) => {
            //SUCCESS :D
            if (responseData) {
                this.onUpdateStatusSuccess(responseData, updateUi);
            } else {
                const e = new core.Error("Les données retournées par le système de mise à jour des notifications sont invalides.");
                this.onUpdateStatusError([e]);
            }
        }, (errors, config) => {
            //ERROR :'(
            this.onUpdateStatusError(errors);
        });
    }
}

export = Notifications;